import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/styles';
import { tabsStyles } from '../material-styles';

const ContainedTabs = withStyles(tabsStyles)(Tabs);

export default ContainedTabs;
